import { ref } from 'vue'
import { defineStore } from 'pinia'
import * as api from '@/api/v4/resume'

export const useResumeStore = defineStore('resumeStore', () => {
  const loadingResumes = ref(false)
  const resumeList = ref<any>([])
  const fullResumeList = ref<any>([])
  const focusedResume = ref<any>(null)
  const hasFetchedResumes = ref(false)

  const fetchResumes = async (
    options = {
      sortBy: 'created_at',
      sortDir: 'desc',
      perPage: 25,
      baseOnly: 1,
    }
  ) => {
    loadingResumes.value = true
    const { data, error } = await api.listResumes(options)
    if (error) {
      loadingResumes.value = false
      return console.error(error)
    }
    loadingResumes.value = false
    resumeList.value = data.data
    hasFetchedResumes.value = true
  }

  const fetchAllResumes = async (
    options = {
      page: 1,
      sortBy: 'created_at',
      sortDir: 'desc',
      perPage: 100,
    }
  ) => {
    const { data, error } = await api.listResumes(options)
    if (error) {
      loadingResumes.value = false
      return console.error(error)
    }
    if (data.meta.current_page < data.meta.last_page) {
      options.page = data.meta.current_page + 1
      fetchAllResumes(options)
    }
    if(data.meta.current_page > 1) {
      fullResumeList.value = [...fullResumeList.value, ...data.data]
    } else {
      fullResumeList.value = data.data
    }
  }

  const unsetBaseResume = async id => {
    resumeList.value = resumeList.value.filter(
      resume => Number(resume.id) !== Number(id)
    )
    const { data, error } = await api.updateResume(id, { is_base: false })
    if (error) {
      return console.error(error)
    }
  }

  const deleteStateRecord = id => {
    resumeList.value = resumeList.value.filter(
      resume => Number(resume.id) !== Number(id)
    )
    fullResumeList.value = fullResumeList.value.filter(
      resume => Number(resume.id) !== Number(id)
    )
  }

  const updateStateRecord = resume => {
    const index = resumeList.value.findIndex(
      r => Number(r.id) === Number(resume.id)
    )
    const fullIndex = fullResumeList.value.findIndex(
      r => Number(r.id) === Number(resume.id)
    )
    if (index >= 0) {
      resumeList.value = resumeList.value.map((r, i) =>
        i === index ? { ...r, ...resume } : r
      )
    }
    if (fullIndex >= 0) {
      fullResumeList.value = fullResumeList.value.map((r, i) =>
        i === fullIndex ? { ...r, ...resume } : r
      )
    }
  }

  const clearResumeList = () => {
    resumeList.value = []
  }

  return {
    resumeList,
    fullResumeList,
    loadingResumes,
    fetchResumes,
    fetchAllResumes,
    unsetBaseResume,
    deleteStateRecord,
    updateStateRecord,
    focusedResume,
    hasFetchedResumes,
    clearResumeList,
  }
})
